import { StandardLayout } from "@/react/components/Layout/StandardLayout";
import { RightSidebarContent } from "@/react/components/Spaces/RightSidebarContent";
import { CurrentPostContextProvider } from "@circle-react/contexts";
import { useHasPostRightSidebar } from "../hooks/useHasPostRightSidebar";

interface RightSidebarProps {
  className?: string;
  postResource: any;
}

export const RightSidebar = ({
  postResource,
  className,
}: RightSidebarProps) => {
  const hasPostRightSidebar = useHasPostRightSidebar();

  return (
    <StandardLayout.Right className={className} hidden={!hasPostRightSidebar}>
      <CurrentPostContextProvider post={postResource?.data}>
        <RightSidebarContent />
      </CurrentPostContextProvider>
    </StandardLayout.Right>
  );
};
